import { render, staticRenderFns } from "./TopicExplorer.vue?vue&type=template&id=11b6a33f"
import script from "./TopicExplorer.vue?vue&type=script&lang=js"
export * from "./TopicExplorer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports